exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollX{overflow-x:auto !important}.portfolio_input{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.portfolio_input div input{border:transparent;border-bottom:1px solid #abaeb8;max-width:150px}.portfolio_input div:first-child{margin-right:20px}@media only screen and (max-width: 375px){.portfolio_input div input{max-width:100px}}.performance_download_btn{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/performance/performance.scss
// module id = 1441
// module chunks = 0